// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__314vn","inputWrap":"CustomTip_inputWrap__3Eovl"};